<template>
  <v-container fill-height>
    <v-row align="center" class="fill-height ma-0" justify="center">
      <ResHubLogo />
    </v-row>

    <v-row  v-if="loading" align="center" class="fill-height ma-0" justify="center">
      <Loader style="height: 200px" />
    </v-row>
   
    <v-row v-else>
      <v-col lg="12" align="center">
        <h2 class="mt-5">
          <b>
            {{ title }}
          </b>
        </h2>
        <h3 class="mt-4" :class="isError ? 'error-text' : 'success-text'">
          <b>
            {{ message }}
          </b>
        </h3>
      </v-col>
    </v-row>
    <ConfirmDlg ref="confirmationModal"></ConfirmDlg>
  </v-container>
</template>

<script>
import ResHubLogo from "@/views/login/ResHubLogo.vue";
import Loader from "@/components/loader/Loader.vue";
import * as firebase from "firebase/app";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { getRegionName } from "@/utils/functionsRegion";

export default {
  components: {
    ResHubLogo,
    Loader,
    ConfirmDlg
  },
  data() {
    return {
      loading: false,
      isError: false,
      title: this.$t('DeleteFamilyHubAccount.Title'),
      message: ""
    };
  },
  async created() {
    const userId = this.$route.params.familyUserId
    const token = this.$route.params.deleteAccountToken
    const familySnap = await firebase.firestore().collection("familyHubUsers").doc(userId).get()

    if (familySnap.exists && familySnap.data().deleteAccountToken === token) {
      const userData = familySnap.data()
      this.$refs.confirmationModal
        .open(this.$t('DeleteFamilyHubAccount.DeletingTitle').replace('{email}', userData.email || userData.name)
          , this.$t('DeleteFamilyHubAccount.AreYouSureYouWantToDeleteYourAccount')
          , false, '', { isPersistent: true })
        .then(async (response) => {
          if (response && response.agree) {
            this.loading = true
            const fnResponse = await firebase.app().functions(getRegionName()).httpsCallable("familyUser-delete")({ id: userId, deleteAccountToken: token })
            this.loading = false
            if (fnResponse.data.data.status === 200) {
              this.message = this.$t('DeleteFamilyHubAccount.AccountDeleted')
              this.title = ''
            }
            else {
              this.isError = true
              this.message = this.$t('DeleteFamilyHubAccount.ErrorDeletingAccount')
            }
          }
        });
    }
    else {
      this.isError = true
      this.message = this.$t('DeleteFamilyHubAccount.InvalidToken')
    }
  }
}
</script>

<style scoped>
.success-text {
  color: #4caf50;
}

.error-text {
  color: #f44336;
}
</style>